import { ReflectiveInjector } from 'injection-js';

import { AccountService } from './account.service';
import { AdminAccountService } from './admin-account.service';
import { AdminCarrierAccountService } from './admin-carrier-account.service';
import { AdminCarrierService } from './admin-carrier.service';
import { AdminManifestService } from './admin-manifest.service';
import { AdminShipmentService } from './admin-shipment.service';
import { AdminUserService } from './admin-user.service';
import { CarrierAccountService } from './carrier-account.service';
import { DashboardService } from './dashboard.service';
import { IntlService } from './intl.service';
import { LogService } from './log.service';
import { MetaDataService } from './meta-data.service';
import { ReportService } from './report.service';
import { SharedService } from './shared.service';
import { ShipmentService } from './shipment.service';
import { SystemConfigService } from './system-config.service';
import { TrackingService } from './tracking.service';
import { UserService } from './user.service';
import { USPSTierConfigService } from './usps-tier-config.service';
import { USPSAutoManifestScheduleService } from './usps-auto-manifest-schedule.service';

const injector = ReflectiveInjector.resolveAndCreate([
	AccountService,
	IntlService,
	LogService,
	DashboardService,
	ShipmentService,
	SharedService,
	ReportService,
	MetaDataService,
	SystemConfigService,
	UserService,
	USPSTierConfigService,
	AdminAccountService,
	CarrierAccountService,
	AdminCarrierService,
	AdminCarrierAccountService,
	AdminShipmentService,
	AdminUserService,
	AdminManifestService,
	TrackingService,
	USPSAutoManifestScheduleService,
]);

export default injector;



// WEBPACK FOOTER //
// ./src/services/index.ts